
export type GetNotificationSettings200Frequency = typeof GetNotificationSettings200Frequency[keyof typeof GetNotificationSettings200Frequency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNotificationSettings200Frequency = {
  IMMEDIATE: 'IMMEDIATE',
  DAILY_DIGEST: 'DAILY_DIGEST',
} as const;
